import React from 'react';
import _ from 'lodash';
import { useQuery, useParameterizedQuery } from 'react-fetching-library';
import { useNavigate } from 'react-router-dom';
import { Typography, Collapse, Stack, Button, Box } from '@mui/material';
import { getLatestFormAction, getClientDataAction } from '../../../services/request';
import { FormPanel } from '../../../components-core/form/FormPanel';
import { useAuthenticated, useResponsive } from '../../../services/hooks';
import { Logo } from '../../../components-core/landing/Logo';
import Footer from '../../../layouts/landing/Footer';

const Header = ({ formIdentifier }) => {
  const isDesktop = useResponsive('up', 'lg');
  const navigate = useNavigate();

  return (
    <Stack direction={isDesktop ? 'row' : 'column'} justifyContent="space-between" alignItems="center" p={2}>
      <Logo />
      <Box sx={{ flex: 1 }}/>
      <Button variant="outlined" href="/login" sx={{ m: isDesktop ? '0' : '20px 0 0 0' }} style={{ color: 'rgb(155, 35, 31)' }}>Zaloguj się</Button>
      <Button
        variant="contained"
        href="/registration"
        sx={{ m: isDesktop ? '0 20px 0 20px' : '20px 0 20px 0' }}
        style={{ color: 'white' }}
      >
        Zarejestruj się
      </Button>
      <Button variant="text" href="https://jujutsupoland.com/" target="_blank" style={{ color: 'rgb(155, 35, 31)' }}>Powrót do strony Mohikan</Button>
    </Stack>
  );
};

const EnrollmentForm = ({ formIdentifier }) => {
  const { loading, payload, error } = useQuery(getLatestFormAction(formIdentifier));
  const { loading: clientLoading, payload: clientPayload, error: clientError, query } = useParameterizedQuery(getClientDataAction);
  const { isAuthenticated } = useAuthenticated();
  const [form, setForm] = React.useState(null);
  const [clientData, setClientData] = React.useState({});
  const [expanded, setExpanded] = React.useState(true);
  const isDesktop = useResponsive('up', 'lg');

  React.useEffect(() => {
    if (!error && !loading) {
      setForm(payload);
      query();
    }
  }, [loading]);

  React.useEffect(() => {
    if (!clientError && !clientLoading) {
      setClientData(clientPayload);
    }
  }, [clientLoading]);

  if (error) {
    return <Typography>Nie udało się załadować formularza</Typography>;
  }

  if (isAuthenticated()) {
    return (
      <>
        <Header formIdentifier={formIdentifier}/>
        {form != null ? <div style={isDesktop ? { paddingLeft: '5vw', paddingRight: '5vw' } : {}}>
          <FormPanel form={form} clientData={clientData} />
        </div> : null}
      </>
    );
  }

  return (
    <>
      <Header formIdentifier={formIdentifier}/>
      {form != null
        ? <>
          <Collapse in={expanded} timeout="auto">
            <div style={isDesktop ? { paddingLeft: '5vw', paddingRight: '5vw' } : {}}>
              <FormPanel form={form} clientData={clientData} />
            </div>
          </Collapse>
        </>
        : null}
      <Footer />
    </>
  );
};

export default EnrollmentForm;
